import { render, staticRenderFns } from "./userProfile.vue?vue&type=template&id=e18c4002&scoped=true&"
import script from "./userProfile.vue?vue&type=script&lang=js&"
export * from "./userProfile.vue?vue&type=script&lang=js&"
import style0 from "./userProfile.vue?vue&type=style&index=0&id=e18c4002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18c4002",
  null
  
)

export default component.exports